export enum CreditCardProcessingMethod {
    CardConnect = 2,
    Stripe = 4,
}
